import { gql } from "@apollo/client";

export const GET_ALL_UBICACION = gql`
query GetAllUbicacion {
    allUbicacion{
            idUbicacion,
            descripcion
      }
}`;